import { Logger } from "../../helpers/Logger";
import { EVENTS, getTrackingId } from "../config/CONSTANTS";

/**
 * @fileoverview Handles tracking events with Google Analytics.
 * @module YouTube
 */

export class YouTubeTracker {
    constructor() {
        this.init();
        this.conversionId = getTrackingId("Youtube_Conversion_ID");
    }

    init() {
        // Check if gtag is loaded
        if ( typeof window.gtag !== "function" ) {
            Logger.warn("Google Analytics (gtag) not found, cannot initialize YouTube tracking");
            return;
        }

        // Check for a Youtube Conversion ID and initialize if it exists
        if ( this.conversionId ) {
            window.gtag('config', this.conversionId);
            Logger.log("YouTube Pixel initialized with ID:", this.conversionId);
        }
    }

    // Track events
    trackEvent(eventType, eventData) {
        // Make sure we have the gtag function available
        if ( typeof window.gtag !== "function" ) {
            Logger.warn("Google Analytics (gtag) not found, cannot track YouTube event");
            return;
        }
        // Check for 'youtube_label' in eventData
        let labelId;
        if ( !eventData.customData.youtube_label ) {
            Logger.warn("Missing youtube label in event data for YouTube tracking", eventData);
            return;
        } else {
            // Set the label ID from the event data
            labelId = eventData.customData.youtube_label;
        }
        // Make sure we have a conversion ID and label ID
        if ( !this.conversionId && !labelId ) {
            Logger.warn("YouTube Conversion ID or Label ID not set, cannot track YouTube event");
            return;
        }

        // Add the send_to property to the event data
        eventData = {
            ...eventData,
            send_to: `${this.conversionId}/${labelId}`
        };

        // Not sure why the developer validated the eventType if it just passes it through if it doesn't match the EVENTS object
        const finalEventType = EVENTS[eventType] || eventType;

        try {
            window.gtag("event", finalEventType, eventData);
            Logger.log(`YouTube event tracked: ${finalEventType}`, eventData);
        } catch (error) {
            Logger.error("Error tracking YouTube event:", error);
        }
    }
}
